module.exports = __webpack_public_path__ + "img/data3-2.317eb8a1.png";